import { useLocation } from "react-router-dom";
import { FUEL_FLAG_MAPPING } from "../../constants/fuelFlag";
import { SUPPLIER_FUEL_TYPE } from "../../constants/tariffInfo";
import AdditionalSupport from "./AdditionalSupport";
import FasterSwitching from "./FasterSwitching";
import Marketing from "./Marketing";
import SmartMeterReadingFrequency from "./SmartMeterReadingFrequency";
import YourAddress from "./YourAddress";
import YourAgreement from "./YourAgreement";
import YourContactDetails from "./YourContactDetails";
import YourMeterDetails from "./YourMeterDetails";
import YourPaymentDetails from "./YourPaymentDetails";
import YourPersonalDetails from "./YourPersonalDetails";

const SwitchingForm = ({
  initialValues,
  supplierName,
  switchValidationSchema,
  supplierTermsInfo,
  values,
  isSubmitting,
}) => {
  const location = useLocation();
  const { currentPage } = location.state;
  const isAdditionalSupportVisible = Boolean(supplierTermsInfo?.psr?.options);
  const isFasterSwitchingVisible = Boolean(
    Array.isArray(
      switchValidationSchema?.customerInfo?.properties?.switchType?.valid
    ) &&
      switchValidationSchema?.customerInfo?.properties?.switchType?.valid
        .length > 1
  );

  const isSmartMeterReadingFrequencyVisible =
    Boolean(
      switchValidationSchema?.customerInfo?.properties?.billingConsentLevel
        ?.required
    ) ||
    Boolean(
      switchValidationSchema?.customerInfo?.properties?.settlementConsentLevel
        ?.required
    );

  const isMprnRequired = Boolean(
    !initialValues?.meterInfo?.mprn &&
      [
        FUEL_FLAG_MAPPING[SUPPLIER_FUEL_TYPE.GAS],
        FUEL_FLAG_MAPPING[SUPPLIER_FUEL_TYPE.ELECGAS],
      ].includes(initialValues?.fuelType)
  );

  const isMpanRequired = Boolean(
    !initialValues?.meterInfo?.mpan &&
      [
        FUEL_FLAG_MAPPING[SUPPLIER_FUEL_TYPE.ELEC],
        FUEL_FLAG_MAPPING[SUPPLIER_FUEL_TYPE.ELECGAS],
      ].includes(initialValues?.fuelType)
  );

  const isMeterDetailsVisible = isMpanRequired || isMprnRequired;

  return (
    switchValidationSchema && (
      <>
        <div className="mt-8 relative">
          <div className="border-t border-[#afb6b9] w-full absolute top-0 left-0">
            <div className="bg-white px-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <span className="font-bold">{currentPage}</span> of{" "}
              <span className="font-bold">2</span>
            </div>
          </div>
        </div>

        {currentPage === 1 && (
          <>
            <YourAddress values={values} />
            <YourPersonalDetails
              switchValidationSchema={switchValidationSchema}
            />
            <YourContactDetails />
            <YourPaymentDetails
              switchValidationSchema={switchValidationSchema}
              supplierName={supplierName}
              supplierServiceUserNumber={
                supplierTermsInfo?.supplierServiceUserNumber
              }
            />
          </>
        )}

        {currentPage === 2 && (
          <>
            {isMeterDetailsVisible && (
              <YourMeterDetails
                isMpanRequired={isMpanRequired}
                isMprnRequired={isMprnRequired}
              />
            )}
            {isAdditionalSupportVisible && (
              <AdditionalSupport
                supplierName={supplierName}
                supplierTermsInfo={supplierTermsInfo}
                values={values}
                isSubmitting={isSubmitting}
              />
            )}
            {isFasterSwitchingVisible && (
              <FasterSwitching isSubmitting={isSubmitting} />
            )}
            {isSmartMeterReadingFrequencyVisible && (
              <SmartMeterReadingFrequency
                config={supplierTermsInfo?.supplierConsent?.meterConsent}
                isSubmitting={isSubmitting}
              />
            )}
            <Marketing
              supplierTermsInfo={supplierTermsInfo}
              isSubmitting={isSubmitting}
            />
            <YourAgreement config={supplierTermsInfo?.supplierTnCDetails} />
          </>
        )}
      </>
    )
  );
};
export default SwitchingForm;
